<!--
分页组件
先注册 调用示例 <fe-page @retrieve="retrieve" :data="pageData" :params="'a'"></fe-page>
retrieve指向调用列表函数，pageData是列表返回数据 data.data
pageSizes可选
retrieve函数有两个参数(currentNo, pageSize)此组件会两个参数都发射出去，但是有在父组件调用retrieve的情况（搜索，重置），所以要函数配合
在retrieve函数
  retrieve(currentNo, pageSize, params) {
  if(pageSize) {                                                    //必要
    this.pageSize = pageSize
  }
  this.currentNo = currentNo ? currentNo: this.currentNo || 1;      //必要

      let url = this.api.retrieve
      let param = {};
      let callback = (data) => {
        this.tableData = data.data.rows;
        this.pageData = data.data;                                    //必要
      }
      this.ax.post(url, param, callback)
  }

retrieve(1)表示当前页为第一页 retrieve()会直接调用当前指定页数
-->
<template>
  <div class="pagination-wrapper">
    <!-- jumper, sizes,  -->
    <el-pagination class="z-table__pagination" background layout="prev, pager, next, total" :page-count="data.pageCount" :currentPage="data.currentNo" :page-sizes="pageSizes ? pageSizes:defaultPageSizes" :page-size="data.pageSize" :total="data.totalElements" @size-change="sizeChange" @current-change="toRetrieve"></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    data: {
      default: ''
    },
    pageSizes: {
      default: ''
    },
    // 返回传进来的类型 为了一些需要其他参数的情况下
    params: {
      default: ''
    },
    // 是否调用created里面的初始化操作 由于tab切换时只需要在切换的时候调用 减少请求
    isInit: {
      default: true
    },
  },
  data () {
    return {
      defaultPageSizes: [10, 20, 30, 50, 80],
      currentSize: 0
    }
  },
  created () {
    // 初始化页组件时请求数据
    if (this.isInit) {
      this.toRetrieve(null)
    }
  },
  methods: {
    // 每页数据条数变化
    sizeChange (size) {
      this.toRetrieve(this.data.currentNo, size)
    },
    // 当前页改变
    toRetrieve (currentNo, size) {
      if (!size && !this.currentSize) {
        let pageSize = this.pageSizes
          ? this.pageSizes[0]
          : this.defaultPageSizes[0]
        this.currentSize = pageSize
      }
      if (size) {
        this.currentSize = size
      }
      this.$emit('retrieve', currentNo, this.currentSize, this.params)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination-wrapper {
  text-align: right;
  padding: 5px;
}
.z-table__pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
